import { useUpdate } from '@lib/systems/update'
import { vector } from '@lib/util/vector'

export const LEFT_BUTTON = 0
export const MIDDLE_BUTTON = 1
export const RIGHT_BUTTON = 2

let moveHandler
let downHandler
let upHandler
let clickHandler
let contextmenuHandler
let resizeHandler

class MouseInput {
  constructor () {
    this.scale = 3
    this.screenWidth = 320
    this.screenHeight = 180
    this.position = vector()
    this.brect = undefined
    this.held = false
    this.pressed = false
    this.pressedThisFrame = false
  }

  btnPressed (which) {
    return this.pressed === which
  }

  btnHeld (which) {
    return this.held === which
  }

  move (evt) {
    const w = (window.innerWidth - (this.screenWidth * this.scale)) / 2
    const h = (window.innerHeight - (this.screenHeight * this.scale)) / 2
    const mx = ((evt.touches && evt.touches[0].clientX) || evt.clientX) - w
    const my = ((evt.touches && evt.touches[0].clientY) || evt.clientY) - h

    evt.preventDefault()
    this.position.x = Math.round(mx / this.scale)
    this.position.y = Math.round(my / this.scale)
  }

  down (evt) {
    evt.preventDefault()
    this.held = evt.button
    this.pressed = evt.button
    this.pressedThisFrame = true
  }

  up (evt) {
    evt.preventDefault()
    this.held = false
  }

  touchdown (evt) {
    evt.preventDefault()
    this.move(evt)
    this.held = 0
    this.pressed = 0
    this.pressedThisFrame = true
  }

  update () {
    if (!this.pressedThisFrame) this.pressed = false
    this.pressedThisFrame = false
  }

  resize (width, height, scale) {
    this.scale = scale
    this.screenWidth = width
    this.screenHeight = height
  }
}

export const input = new MouseInput()

export function enableMouseInput (el, options = {
  scale: 3,
  screenWidth: 320,
  screenHeight: 180
}) {
  input.scale = options.scale
  input.screenWidth = options.screenWidth
  input.screenHeight = options.screenHeight

  if (moveHandler) el.removeEventListener('mousemove', moveHandler)
  if (downHandler) el.removeEventListener('mousedown', downHandler)
  if (upHandler) el.removeEventListener('mouseup', upHandler)
  if (clickHandler) el.removeEventListener('click', clickHandler)
  if (contextmenuHandler) el.removeEventListener('contextmenu', contextmenuHandler)
  if (resizeHandler) window.removeEventListener('resize', resizeHandler)

  el.addEventListener('mousemove', moveHandler = input.move.bind(input))
  el.addEventListener('mousedown', downHandler = input.down.bind(input))
  el.addEventListener('mouseup', upHandler = input.up.bind(input))
  el.addEventListener('click', clickHandler = evt => evt.preventDefault())
  el.addEventListener('contextmenu', contextmenuHandler = evt => evt.preventDefault())

  el.addEventListener('touchmove', moveHandler = input.move.bind(input))
  el.addEventListener('touchstart', downHandler = input.touchdown.bind(input))
  el.addEventListener('touchend', upHandler = input.up.bind(input))

  window.addEventListener('resize', resizeHandler = () => {
    input.brect = el.getBoundingClientRect()
  })
  resizeHandler()

  useUpdate(() => {
    input.update()
  }, {
    updateOrder: -1
  })
}

export function useMouseInput () {
  return {
    position: input.position,
    btnPressed: input.btnPressed.bind(input),
    btnHeld: input.btnHeld.bind(input)
  }
}
